// extracted by mini-css-extract-plugin
export default {"center":"CheckboxGridColumn_center__LOGTJ"};